import { render, staticRenderFns } from "./recommend_content_list.vue?vue&type=template&id=728a8c4b"
import script from "./recommend_content_list.vue?vue&type=script&lang=js"
export * from "./recommend_content_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports